/* ===== La Tocanterie — theme.js ===== */
(function(){
  "use strict";
  var money = window.LT_MONEY_FORMAT || "{{amount}} €";
  function formatMoney(cents){
    var v = (cents/100);
    var s = v.toLocaleString('fr-FR',{minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits:2});
    return s + " €";
  }

  /* ---- Live clock (logo) ---- */
  function tickClocks(){
    var now = new Date();
    var s = now.getSeconds(), m = now.getMinutes(), h = now.getHours()%12;
    var hA = h*30 + m*0.5, mA = m*6 + s*0.1, sA = s*6;
    document.querySelectorAll('.lt-clock').forEach(function(svg){
      var hh = svg.querySelector('.lt-h'), mm = svg.querySelector('.lt-m'), ss = svg.querySelector('.lt-s');
      if(hh) hh.style.transform = 'rotate('+hA+'deg)';
      if(mm) mm.style.transform = 'rotate('+mA+'deg)';
      if(ss) ss.style.transform = 'rotate('+sA+'deg)';
    });
  }
  tickClocks(); setInterval(tickClocks, 1000);

  /* ---- Header scroll ---- */
  var header = document.querySelector('.site-header');
  function onScroll(){ if(header){ header.classList.toggle('scrolled', window.scrollY > 40); } }
  window.addEventListener('scroll', onScroll); onScroll();

  /* ---- Mobile nav ---- */
  var mnav = document.querySelector('.mnav');
  document.querySelectorAll('[data-open-mnav]').forEach(function(b){ b.addEventListener('click', function(){ mnav && mnav.classList.add('open'); }); });
  document.querySelectorAll('[data-close-mnav]').forEach(function(b){ b.addEventListener('click', function(){ mnav && mnav.classList.remove('open'); }); });

  /* ---- Search overlay ---- */
  var searchov = document.querySelector('.searchov');
  document.querySelectorAll('[data-open-search]').forEach(function(b){ b.addEventListener('click', function(){
    if(searchov){ searchov.classList.add('open'); var i = searchov.querySelector('input'); i && i.focus(); }
  }); });
  document.querySelectorAll('[data-close-search]').forEach(function(b){ b.addEventListener('click', function(){ searchov && searchov.classList.remove('open'); }); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ searchov && searchov.classList.remove('open'); closeDrawer(); } });

  /* ---- Cart drawer ---- */
  var drawer = document.querySelector('.cart-drawer');
  var scrim = document.querySelector('.scrim');
  function openDrawer(){ drawer && drawer.classList.add('open'); scrim && scrim.classList.add('open'); }
  function closeDrawer(){ drawer && drawer.classList.remove('open'); scrim && scrim.classList.remove('open'); }
  document.querySelectorAll('[data-open-cart]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); renderCart(); openDrawer(); }); });
  document.querySelectorAll('[data-close-cart]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
  scrim && scrim.addEventListener('click', closeDrawer);

  function updateCount(c){ document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = c; el.classList.toggle('hidden', c===0); }); }

  function renderCart(){
    var body = drawer && drawer.querySelector('.drawer-body');
    var foot = drawer && drawer.querySelector('.drawer-foot');
    if(!body) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      updateCount(cart.item_count);
      if(cart.item_count === 0){
        body.innerHTML = '<div class="empty">Votre panier est vide.<br>Le bon garde-temps vous attend au catalogue.</div>';
        if(foot) foot.innerHTML = '';
        return;
      }
      var html = '';
      cart.items.forEach(function(it){
        var img = it.image ? '<img class="lv" src="'+it.image+'" alt="">' : '<div class="lv"></div>';
        html += '<div class="litem">'+img+'<div style="flex:1">'+
          '<div class="lb">'+(it.vendor||'')+'</div>'+
          '<div class="lname">'+it.product_title+'</div>'+
          '<div style="color:var(--gold);font-size:14px;margin-top:4px">'+formatMoney(it.final_price)+'</div>'+
          '<div class="qty"><button data-ck="'+it.key+'" data-d="-1">&minus;</button><span>'+it.quantity+'</span><button data-ck="'+it.key+'" data-d="1">+</button></div>'+
          '<button class="rm" data-rm="'+it.key+'">Retirer</button>'+
        '</div></div>';
      });
      body.innerHTML = html;
      if(foot){
        foot.innerHTML = '<div class="subtotal"><span class="muted">Sous-total</span><b>'+formatMoney(cart.total_price)+'</b></div>'+
          '<a class="btn solid full" href="/checkout"><span>Passer commande</span></a>'+
          '<a href="/cart" style="display:block;text-align:center;margin-top:14px;color:var(--muted);font-size:12px;letter-spacing:.14em;text-transform:uppercase">Voir le panier</a>';
      }
      body.querySelectorAll('[data-ck]').forEach(function(b){ b.addEventListener('click', function(){ changeQty(b.getAttribute('data-ck'), parseInt(b.getAttribute('data-d'),10)); }); });
      body.querySelectorAll('[data-rm]').forEach(function(b){ b.addEventListener('click', function(){ changeLine(b.getAttribute('data-rm'), 0); }); });
    });
  }

  function changeQty(key, delta){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var item = cart.items.filter(function(i){return i.key===key;})[0];
      if(!item) return;
      changeLine(key, Math.max(0, item.quantity + delta));
    });
  }
  function changeLine(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(function(){ renderCart(); });
  }

  /* ---- Add to cart (product form) ---- */
  document.querySelectorAll('form[data-product-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.querySelector('span') : null;
      var orig = label ? label.textContent : '';
      if(label) label.textContent = 'Ajout…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id: form.querySelector('[name=id]').value, quantity: 1})})
        .then(function(r){return r.json();})
        .then(function(){ if(label) label.textContent = orig; renderCart(); openDrawer(); })
        .catch(function(){ if(label) label.textContent = orig; });
    });
  });

  /* ---- Reveal on scroll ---- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.reveal');
  if(reduce || !('IntersectionObserver' in window)){
    reveals.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    },{threshold:.12, rootMargin:'0px 0px -6% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* init count */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ updateCount(c.item_count); });
})();
